import store from "../store/store";

function findInTree(list, callbackCompare) {
    if ((list || []).length === 0) {
        return;
    }

    for (let i = 0; i < list.length; i++) {
        let value = list[i];
        let target = callbackCompare(value) || findInTree(value.children, callbackCompare);
        if (target) {
            return value;
        }
    }
}

export const menuHelper = {
    getMenu: () => {
        let states = store.getState();
        const isAvailableMenu = states.menu.isAvailableMenu;
        const menuLocal = JSON.parse(localStorage.getItem('menu') || '{}');
        let menu = isAvailableMenu ? menuLocal : states.menu.items;
        return menu;
    },
    checkMultiPermission: (urls) => {
        let states = store.getState();
        const isAvailableMenu = states.menu.isAvailableMenu;
        const menuLocal = JSON.parse(localStorage.getItem('menu') || '{}');
        let menu = isAvailableMenu ? menuLocal : states.menu.items;
        let rules = {};
        urls.forEach((value) => {
            rules[value] = !!findInTree(menu, (m) => m?.url?.toLowerCase() === value?.toLowerCase());
        });
        return rules;
    }
};